module.exports = __webpack_public_path__ + "static/media/203.eb85b181.png";